/**
 * Created by guyavarham on 17/07/2017.
 */

import _ from 'lodash';

export const getBrowserHeight = state => _.get(state, 'browser.height', 0);
export const lessThanMedium = state => state.browser.lessThan.medium;
